






































// @ is an alias to /src
import apiProfilExclusion from '@/api/profilExclusion'
import axios from 'axios'
import { Component, Vue, Watch } from 'vue-property-decorator'
import CheckState from '@/components/shared/CheckState.vue'
import { toSubArray } from '@/utils/groupBy'
import { directPayloadQuery } from '@/utils/api'
import { AloProfilExclusion, getDefaultAloProfilExclusion } from '@/models/alo/AloProfilExclusion'
import { AloBase } from '@/models/alo/AloBase'
import ReadConfig from '@/components/profilExclusion/read/ReadConfig.vue'
import ReadCodic from '@/components/profilExclusion/read/ReadCodic.vue'
import ReadFlux from '@/components/profilExclusion/read/ReadFlux.vue'
import ReadMarques from '@/components/profilExclusion/read/ReadMarques.vue'


@Component({
  name: 'ModifyProfils', 
  props: {
    profilExclusionId:Number
  },
  components: { CheckState,ReadConfig,ReadCodic,ReadMarques,ReadFlux},
})

export default class ModifyProfils extends Vue {
  private profilExclusionId!: number
  private showError = false
  private rightDrawer = false

  private loadingProfilExclusion = false
  private loadingItemsProfilExclusion = false

  private showExport = false
  private exporting = false
  private exportingName = ""
  
 
  get isCentralWeb() {return this.$store.myGetters.isCentralWeb}
  get isDartyPro() {return this.$store.myGetters.isDartyPro}


  get profilExclusion() { 
    return {...getDefaultAloProfilExclusion(),...this.$store.myGetters.profilExclusion[this.profilExclusionId]}
  }  

  loadProfilExclusion(){        
    this.loadingProfilExclusion = true
    this.$store.myActions.ADM_PROFIL_EXCLUSION_DETAIL_REQUEST(this.profilExclusionId)
    .catch(()=>{
      this.$router.push({name:"ProfilExclusion"})
    })
    .finally(() => {
      this.loadingProfilExclusion = false
    })
  }


  @Watch('profilExclusionId')
  onProfilExclusionIdChanged(){
   this.loadProfilExclusion()
  }

  created(){        
     this.$store.myActions.ADM_FLUX_ENSURE().then(() =>{
      this.loadProfilExclusion()      
    })      
  }
  
  get arianeItems() {
    const arianeItems =  [
        {
          text: 'ProfilExclusion',
          disabled: false,          
          to: {name:'ProfilExclusion'},
          exact:true
        }
      ]
    if(this.profilExclusion) {
        arianeItems.push({
          text: this.profilExclusion.libelle,
          disabled: true,          
          to: {name:''},
          exact:true
        })
    }
    return arianeItems;
  } 
  
  saveData() {
    this.rightDrawer = false;
  }

  remove(){
    const message = this.profilExclusion.pfeIsActive && this.profilExclusion.flxIds.length > 0?`Attention, ce profil d'exclusion est actuellement actif, il est appliqué à ${this.profilExclusion.flxIds.length} flux (${this.profilExclusion.flxIds}) La suppression de ce profil entraîne sa désactivation sur l'ensemble des flux rattachés. Etes-vous sûr de vouloir supprimer complètement ce profil d'exclusion ?`:"Etes-vous sûr de vouloir supprimer complètement ce profil d'exclusion ?"
    this.$confirm(message).then((answer)=>{
      if(answer){
        this.$store.myActions.ADM_PROFIL_EXCLUSION_DELETE_REQUEST(this.profilExclusion.id).then(()=>{
          this.$router.push({name:'ProfilExclusion'})
        })
      }
    })
  }

  evaluate()  {
    //todo faire l'evaluation
    alert("Fonction non implémentée pour le moment")    
  }

  exportCsv() {
    this.showExport = true
  }


}
